import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import { CopyOutlined, PhoneOutlined, MailOutlined } from '@ant-design/icons';
import { getFriendlyTime } from '@zorba-shared/core/Services/textService';
import { buildBuyerPageUrl } from '../../../../services/urlBuilderService';
import { showSuccessToast } from '../../../../services/notificationsService';
import { ZorbaSelect } from '../../../../components/forms';

export const ADMIN_USERS = [
  'anj@getzorba.com',
  'or@getzorba.com',
  'kobi@getzorba.com',
  'mateusz.kwasny@getzorba.com',
];

export const getAccessibleAgents = (userEmail, userId, agents = [], userDetails) => {
  if (!userDetails) return;
  if (userDetails.permissions.includes('admin') || userDetails.permissions.includes('superuser')) {
    return [{ label: 'All Agents', value: '' }, ...agents];
  }

  return agents.filter((agent) => agent.value === userId);
};

export const daysOptions = [
  { label: '7 days', value: 7 },
  { label: '30 days', value: 30 },
  { label: '90 days', value: 90 },
  { label: '120 days', value: 120 },
];

export const getTableColumns = ({
  isAdmin,
  editingKey,
  setEditingKey,
  handleAssociatedBuyerAgentChange,
  tempValue,
  agents = [],
}) => [
    {
      title: 'User',
      key: 'name',
      width: 200,
      render: (data) => {
        const { name, organizationName, isSoftPaused } = data;
        return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <Link target="_blank" to={`/buyers/${data.buyerId}/${data._id}`}
            style={{
              textDecoration: 'underline',
              color: '#3F434A',
              fontWeight: '500',
              fontSize: '14px',
            }}
          >
            {name}
          </Link>
          <span style={{ color: '#8A9099', fontSize: '10px' }}>
            {organizationName}
          </span>
          {isSoftPaused && (
            <span style={{
              background: '#f0f0f0',
              padding: '2px 6px',
              borderRadius: '4px',
              fontSize: '10px',
              color: '#666',
              display: 'inline-block',
              width: 'fit-content'
            }}>
              Soft Paused
            </span>
          )}
        </div>
      )}
    },
    {
      title: 'Buyer Agent',
      key: 'buyerAgent',
      width: 200,
      render: ({ buyerAgent, buyerAgentId, _id }, _, index) =>
        isAdmin && editingKey === `${index}-buyerAgent` ? (
          <div style={{ width: '200px' }}>
            <ZorbaSelect
              value={tempValue !== null ? tempValue : buyerAgentId}
              options={[
                { label: 'Clear', value: null },
                ...agents
              ]}
              onChange={(e) => handleAssociatedBuyerAgentChange && handleAssociatedBuyerAgentChange(index, _id, e)}
              onBlur={() => setEditingKey(null)}
              allowClear
            />
          </div>
        ) : (
          <span
            onClick={() => isAdmin && setEditingKey(`${index}-buyerAgent`)}
            style={{ cursor: isAdmin ? 'pointer' : 'default' }}
          >
            {buyerAgent || 'Not assigned'}
          </span>
        ),
    },
    {
      title: 'Last login',
      key: 'lastLogin',
      width: 120,
      sorter: (a, b) => new Date(a.lastLogin) - new Date(b.lastLogin),
      render: ({ lastLogin }) => lastLogin,
    },
    {
      title: 'Deals Sent',
      key: 'requestedOffers',
      width: 100,
      sorter: (a, b) => a.requestedOffers - b.requestedOffers,
      render: ({ requestedOffers }) => requestedOffers,
    },
    {
      title: 'Underwritten',
      key: 'offers',
      width: 100,
      // sorter: (a, b) => a.offers - b.offers,
      render: ({ offers, rejectedByBuyer, requestedOffers }) => `${offers + rejectedByBuyer}`,
    },
    {
      title: 'Offers Made',
      key: 'offers',
      width: 100,
      sorter: (a, b) => a.offers - b.offers,
      render: ({ offers }) => offers,
    },
    {
      title: 'Rejected by Buyer',
      key: 'rejectedByBuyer',
      width: 120,
      sorter: (a, b) => a.rejectedByBuyer - b.rejectedByBuyer,
      render: ({ rejectedByBuyer }) => rejectedByBuyer,
    },
    {
      title: 'Did Not Respond',
      key: 'didNotRespond',
      width: 120,
      sorter: (a, b) => a.didNotRespond - b.didNotRespond,
      render: ({ didNotRespond }) => didNotRespond,
    },
    {
      title: 'Offers Submitted to Seller',
      key: 'offersSubmittedToTheSeller',
      width: 120,
      sorter: (a, b) => a.offersSubmittedToTheSeller - b.offersSubmittedToTheSeller,
      render: ({ offersSubmittedToTheSeller }) => offersSubmittedToTheSeller,
    },
    {
      title: 'Accepted Offers',
      key: 'acceptedOffers',
      width: 100,
      sorter: (a, b) => a.acceptedOffers - b.acceptedOffers,
      render: ({ acceptedOffers }) => acceptedOffers,
    },
    {
      title: 'Buybox',
      key: 'buyBoxCounter',
      width: 100,
      render: ({ buyBoxCounter }) => buyBoxCounter,
    },
    {
      title: 'Is Active',
      key: 'isActive',
      width: 80,
      render: ({ isActive }) =>
        isActive ? (
          <span style={{
            background: '#d4edda',
            color: '#155724',
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '10px'
          }}>
            Yes
          </span>
        ) : (
          <span style={{
            background: '#f8d7da',
            color: '#721c24',
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '10px'
          }}>
            No
          </span>
        ),
    },
  ];